import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';

const CTAAnnotation = ({ data }) => {
  const insured = get(
    data,
    'product.institution.details.federally_insured.value',
    null
  );
  const name = get(data, 'product.institution.details.display_name.value');

  let FDICStatus;
  if (insured) {
    if (insured === 'NON_MEMBER_FDIC') {
      /*
        If the institution.details.federally_insured value is FDIC_INSURED,
        the Landing page client should display the insured status as "Deposits are FDIC Insured"
        https://nerdwallet.atlassian.net/browse/BAIN-1300?focusedCommentId=759016
      */
      FDICStatus = 'Deposits are FDIC Insured';
    } else {
      FDICStatus = `Member ${insured}`;
    }
  }

  return (
    <div className="annotation-apply">
      At {name}
      {FDICStatus && ', '}
      {FDICStatus && <br />}
      {FDICStatus}
    </div>
  );
};

CTAAnnotation.propTypes = {
  data: PropTypes.shape({
    product: PropTypes.shape({
      institution: PropTypes.shape({
        details: PropTypes.shape({
          federally_insured: PropTypes.shape({
            value: PropTypes.string,
          }),
          display_name: PropTypes.shape({
            value: PropTypes.string,
          }),
        }),
      }),
    }),
  }),
};

CTAAnnotation.displayName = 'CTAAnnotation';

export default CTAAnnotation;
